module.exports = __webpack_public_path__ + "img/nb-6.6743a49e.png";